
document.addEventListener('DOMContentLoaded', function() {
    // Function to setup uppercase alphanumeric validation for inputs
    function setupInputValidation() {
        // Get all input fields with the specific patterns for Bold Product Options
        const customizationInputs = document.querySelectorAll('input[name^="properties["]');
        
        customizationInputs.forEach(input => {
            // Only apply to text inputs
            if (input.type !== 'text') return;
            
            // Convert existing value to uppercase on load
            if (input.value) {
                input.value = input.value.toUpperCase();
            }
            
            // Handle input as user types
            input.addEventListener('input', function(e) {
                let value = e.target.value;
                
                // Remove any characters that aren't letters, numbers, or spaces
                value = value.replace(/[^A-Za-z0-9\s]/g, '');
                
                // Convert to uppercase
                value = value.toUpperCase();
                
                // Update the input value
                e.target.value = value;
            });
            
            // Handle paste events
            input.addEventListener('paste', function(e) {
                e.preventDefault();
                
                // Get pasted text
                let pastedText = (e.clipboardData || window.clipboardData).getData('text');
                
                // Clean and convert the pasted text
                pastedText = pastedText.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                
                // Insert the cleaned text
                const start = this.selectionStart;
                const end = this.selectionEnd;
                const text = this.value;
                const before = text.substring(0, start);
                const after = text.substring(end, text.length);
                
                this.value = before + pastedText + after;
                this.selectionStart = this.selectionEnd = start + pastedText.length;
                
                // Trigger input event for any additional handlers
                this.dispatchEvent(new Event('input', { bubbles: true }));
            });
            
            // Force uppercase on blur (when user clicks away)
            input.addEventListener('blur', function(e) {
                e.target.value = e.target.value.toUpperCase();
            });
        });
    }
    
    // Setup input validation when page loads
    setupInputValidation();
    
    // Also setup validation when new elements might be added dynamically
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                setupInputValidation();
            }
        });
    });
    
    // Start observing the document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Attach the event listener to the Add to Cart button
    document.querySelector('button[name="add"]').addEventListener('click', function(e) {
        // Prevent form submission if validation fails
        let formIsValid = true;
        let errorMessages = new Set(); // Use a Set to prevent duplicate messages

        // Get the error message container
        const errorMessageContainer = document.getElementById('add-to-cart-error-message');
        errorMessageContainer.innerHTML = ''; // Clear previous error messages
        errorMessageContainer.style.display = 'none'; // Hide the container initially

        // Remove any previous error highlights
        document.querySelectorAll('.bold_option_element input, .bold_option_element select, .bold_option_element textarea').forEach(function(inputElement) {
            inputElement.classList.remove('pv-bold-input-error'); // Remove error class
        });
        document.querySelectorAll('.bold_option_element').forEach(function(element) {
            element.classList.remove('pv-bold-input-error'); // Remove error class for containers
        });

        // Find all bold_option elements on the page
        document.querySelectorAll('.bold_option').forEach(function(option) {
            // Check if the bold_option_title contains a "*"
            const optionTitle = option.querySelector('.bold_option_title');
            let titleText = optionTitle ? optionTitle.textContent.trim() : '';

            if (optionTitle && titleText.includes('*')) {
                let errorFound = false; // Track if an error is found in this option set

                // Find the corresponding bold_option_element for input types
                const inputElement = option.querySelector('.bold_option_element input, .bold_option_element textarea, .bold_option_element select');

                if (inputElement) {
                    // For checkboxes and radio buttons, ensure at least one is selected
                    if ((inputElement.type === 'checkbox' || inputElement.type === 'radio') && !inputElement.checked) {
                        const checkedOption = option.querySelector('.bold_option_element input:checked');
                        if (!checkedOption) {
                            formIsValid = false;
                            errorMessages.add(`${titleText} is required.`);
                            inputElement.closest('.bold_option_element').classList.add('pv-bold-input-error'); // Highlight the container
                            errorFound = true;
                        }
                    }

                    // For text fields, ensure it is filled out
                    if (inputElement.type === 'text' && inputElement.value.trim() === '') {
                        formIsValid = false;
                        errorMessages.add(`${titleText} is required.`);
                        inputElement.classList.add('pv-bold-input-error'); // Highlight the text input
                        errorFound = true;
                    }

                    // For select dropdowns, ensure a valid option is chosen
                    if (inputElement.tagName === 'SELECT' && inputElement.value === '') {
                        formIsValid = false;
                        errorMessages.add(`${titleText} is required.`);
                        inputElement.classList.add('pv-bold-input-error'); // Highlight the dropdown
                        errorFound = true;
                    }
                }

                // Check for swatches: any input that has a type of checkbox or radio but is not a standard input
                const swatchInputs = option.querySelectorAll('.bold_option_element input[type="radio"], .bold_option_element input[type="checkbox"]');
                if (swatchInputs.length > 0 && !errorFound) {
                    let swatchSelected = false;
                    swatchInputs.forEach(function(swatchInput) {
                        if (swatchInput.checked) {
                            swatchSelected = true;
                        }
                    });
                    if (!swatchSelected) {
                        formIsValid = false;
                        errorMessages.add(`${titleText} is required.`);
                        const swatchContainer = option.querySelector('.bold_option_element');
                        if (swatchContainer) {
                            swatchContainer.classList.add('pv-bold-input-error'); // Highlight swatch container
                        }
                    }
                }

                // Handle cases where input might be hidden/conditional and skip those fields
                const hiddenInputElement = option.querySelector('.bold_option_element input[type="hidden"]');
                if (hiddenInputElement && hiddenInputElement.value === '') {
                    formIsValid = false;
                    errorMessages.add(`${titleText} is required.`);
                    hiddenInputElement.closest('.bold_option_element').classList.add('pv-bold-input-error');
                }
            }
        });

        // If the form is not valid, prevent adding to cart and show error message
        if (!formIsValid) {
            e.preventDefault(); // Prevent the form from submitting

            // Display the error messages in the error container with customized styling
            errorMessageContainer.style.display = 'block'; // Make the container visible
            errorMessageContainer.innerHTML = `
                <div style="border: 3px solid red; padding: 10px; margin-top: 10px; font-size: 14px;">
                    <center><p style="font-weight: bold;">⚠️ Missing choices for selected options ⚠️</p></center>
                    <ul style="font-size: 14px;">` + Array.from(errorMessages).map(msg => `<li>${msg}</li>`).join('') + `</ul>
                </div>`;
        }
    });
});
